/* eslint-disable max-len */
import dateTimeMask from './dateTimeMask'

/**
 * Standard date-time format pattern including seconds.
 *
 * This pattern extends the base `dateTimeMask` by appending `:ss` to include seconds in the formatted output.
 * Intended for use wherever a consistent date-time format with seconds is required (e.g., display, logging).
 *
 * @default "{dateTimeMask}:ss"
 */
export default `${dateTimeMask}:ss`
